exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".o-ProductPrice__info {\n  display: inline-block;\n  font-size: 0.55em;\n  text-align: left; }\n\n.o-ProductPrice__info--stacked {\n  display: block; }\n", ""]);

// exports
